import api from './api'

const kauBasePath = '/api/v1/kau'

export async function createRequest(kauRequest) {
  const resp = await api.post(`${kauBasePath}/createRequest`, kauRequest)
  return resp.data
}

export async function processResponse(kauResponse) {
  const resp = await api.post(`${kauBasePath}/processResponse`, kauResponse)
  return resp.data
}

export async function getFullName(relayState) {
  const resp = await api.post(`${kauBasePath}/get-full-name`, { relayState })
  return resp.data
}
